<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="form-group row gutter-5 align-items-center">
                <div class="col-5 col-md-4 texto-morado-oscuro font-weight-medium">
                    Nombre y apellido
                </div>
                <div class="col-7 col-md-8">
                    <input type="text" v-model="$v.nombres.$model" class="form-control radio-10 border-morado-oscuro">
                </div>
                <div class="col-7 col-md-8 mt-1 offset-5 offset-md-4" v-show="$v.nombres.$error">
                    <div class="font-10 texto-rojo font-italic">Campo obligatorio</div>
                </div>
            </div>
            <div class="form-group row gutter-5 align-items-center">
                <div class="col-5 col-md-4 texto-morado-oscuro font-weight-medium">
                    Teléfono
                </div>
                <div class="col-7 col-md-8">
                    <input type="text" v-model="$v.telefono.$model" class="form-control radio-10 border-morado-oscuro">
                </div>
                <div class="col-7 col-md-8 mt-1 offset-5 offset-md-4" v-show="$v.telefono.$error">
                    <div class="font-10 texto-rojo font-italic">Ingrese un número de teléfono válido</div>
                </div>
            </div>
            <div class="form-group row gutter-5 align-items-center">
                <div class="col-5 col-md-4 texto-morado-oscuro font-weight-medium">
                    Empresa
                </div>
                <div class="col-7 col-md-8">
                    <input type="text" v-model="$v.empresa.$model" class="form-control radio-10 border-morado-oscuro">
                </div>
                <div class="col-7 col-md-8 mt-1 offset-5 offset-md-4" v-show="$v.empresa.$error">
                    <div class="font-10 texto-rojo font-italic">Campo obligatorio</div>
                </div>
            </div>
            <div class="form-group row gutter-5 align-items-center">
                <div class="col-5 col-md-4 texto-morado-oscuro font-weight-medium">
                    Cargo
                </div>
                <div class="col-7 col-md-8">
                    <input type="text" v-model="cargo" class="form-control radio-10 border-morado-oscuro">
                </div>
            </div>
            <div class="form-group row gutter-5 align-items-center">
                <div class="col-5 col-md-4 texto-morado-oscuro font-weight-medium">
                    Correo electrónico
                </div>
                <div class="col-7 col-md-8">
                    <input type="text" v-model="$v.correo.$model" class="form-control radio-10 border-morado-oscuro">
                </div>
                <div class="col-7 col-md-8 mt-1 offset-5 offset-md-4" v-show="$v.correo.$error">
                    <div class="font-10 texto-rojo font-italic">Correo inválido, campo obligatorio</div>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="py-1 mb-2 font-weight-medium">Mensaje</div>
            <div>
                <textarea class="form-control radio-10 border-morado-oscuro" v-model="mensaje" cols="30" rows="8"></textarea>
            </div>
        </div>
        <div class="col-12 mt-3 mt-lg-0 text-center">
            <button v-on:click="enviarmensaje" class="btn btn-morado-oscuro texto-blanco py-1 px-4 radio-10">Enviar mensaje</button>
        </div>
        <div class="text-center w-100 pt-2" v-show="mensajeenviado">{{mensajeenviado}}</div>
    </div>
</template>
<script>
    import { modalnotificaciones } from '@resources/helpers.js'
    import { required, email, numeric } from '@public/validators.min'
    export default {
        data (){
            return {
                nombres: '',
                telefono: '',
                empresa: '',
                cargo: '',
                correo: '',
                mensaje: '',
                mensajeenviado: ''
            }
        },
        validations: {
            nombres: { required },
            correo: { required, email },
            telefono: { required, numeric },
            empresa: { required }
        },
        methods: {
            enviarmensaje () {
                let titulomodal = 'Aviso'
                let self = this
                self.$v.$touch()
                if (self.$v.$invalid) {
                    modalnotificaciones(titulomodal, 'Complete los campos obligatorios')
                } else {
                    axios
                        .post('enviarcontacto',{
                            nombres : self.nombres,
                            empresa: self.empresa,
                            cargo: self.cargo,
                            correo: self.correo,
                            telefono: self.telefono,
                            mensaje: self.mensaje,
                        })
                        .then(response => {
                            Object.assign(this.$data, this.$options.data.call(this))
                            self.$v.$reset()
                            modalnotificaciones(titulomodal, 'Hemos recibido su mensaje nos pondremos en contacto')
                            self.mensajeenviado = 'Hemos recibido su mensaje nos pondremos en contacto'
                            setTimeout(function(){
                                self.mensajeenviado = ''
                            }, 5000);
                        })
                        .catch(error => {
                            modalnotificaciones(titulomodal, 'Verifique los campos del formulario')
                        })
                        .finally(

                        )
                }
            }
        }
    }
</script>
